import CouponApplied from './CouponApplied.jsx';

export default CouponApplied;